import { useRouter } from "next/router";
import MedspaFooter from "@/components/common/footer/medspaFooter";
import { MedspaContactInfoProps } from "../medspaContactInfo";

export default function OnlineStoreFooter({
  medspaSlug,
  cherryIntegrationV1Enabled,
  ...props
}: MedspaContactInfoProps & {
  medspaSlug: string;
  cherryIntegrationV1Enabled: boolean;
}) {
  const { push } = useRouter();

  const action = {
    buttonText: "Book an appointment",
    onClick: () => push(`/booking/${medspaSlug}`),
  };

  return (
    <MedspaFooter
      medspaSlug={medspaSlug}
      additionalAction={action}
      affirmEnabled={cherryIntegrationV1Enabled}
      {...props}
    />
  );
}
